import axios from 'lib/axios';

import {
  USERS_LOADING,
  USERS_RECEIVED,
  USERS_ERROR,
  USERS_INVITE_SENT,
  USERS_INVITE_ERROR,
  USERS_INVITE_LOADING,
  USER_INVITES_RECEIVED
} from 'constants/actions';

import {
  E_USERS_UNKNOWN,
  E_USERS_INVITE_UNKNOWN
} from 'constants/errors';

import { dispatcher } from 'lib/redux';

import { M_USER_INVITE_SENT } from 'constants/messages';

import { dispatchSetMessage } from './messages';

export const fetchUsers = () => async () => {
  dispatcher(USERS_LOADING, true);

  try {
    var response = await axios.get('users');

    dispatcher(USERS_LOADING, false);
    dispatcher(USERS_RECEIVED, response.data);
  } catch (e) {
    dispatcher(USERS_LOADING, false);

    if (e.canceled) return;

    try {
      var data = JSON.parse(e.request.responseText);
      dispatcher(USERS_ERROR, data.error);
    } catch (e) {
      dispatcher(USERS_ERROR, E_USERS_UNKNOWN);
    }
  }
};

export const fetchUserInvitations = () => async () => {
  dispatcher(USERS_LOADING, true);

  try {
    var response = await axios.get('users/invitations');

    dispatcher(USERS_LOADING, false);
    dispatcher(USER_INVITES_RECEIVED, response.data);
  } catch (e) {
    dispatcher(USERS_LOADING, false);

    if (e.canceled) return;

    try {
      var data = JSON.parse(e.request.responseText);
      dispatcher(USERS_ERROR, data.error);
    } catch (e) {
      dispatcher(USERS_ERROR, E_USERS_UNKNOWN);
    }
  }
};

export const inviteUser = (inviteData) => async (dispatch) => {
  dispatcher(USERS_INVITE_LOADING, true);
  try {
    await axios.post('users', inviteData);

    dispatcher(USERS_INVITE_LOADING, false);
    dispatcher(USERS_INVITE_SENT);
    dispatchSetMessage(M_USER_INVITE_SENT);
    dispatch(fetchUserInvitations());
  } catch (e) {
    dispatcher(USERS_INVITE_LOADING, false);

    if (e.canceled) return;

    try {
      var data = JSON.parse(e.request.responseText);
      dispatcher(USERS_INVITE_ERROR, data.message);
    } catch (e) {
      dispatcher(USERS_INVITE_ERROR, E_USERS_INVITE_UNKNOWN);
    }
  }
};

